import { render, staticRenderFns } from "./ParamProjects.vue?vue&type=template&id=5c181c16&scoped=true&"
import script from "./ParamProjects.vue?vue&type=script&lang=js&"
export * from "./ParamProjects.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c181c16",
  null
  
)

export default component.exports